import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';
import { TOP_BAR_TOTAL_HEIGHT } from './Menu/Menu.styles';

export const buttonHitSlop = { left: 15, right: 15, top: 5, bottom: 5 };

const baseStyles = {
    buttonComponent: { justifyContent: 'flex-end', height: '100%' },
    buttonStrip: { height: 2 },
    tabBarContainer: {
        backgroundColor: Device.isTabletOrWeb ? 'rgba(0,0,0,0.9)' : 'rgba(80, 80, 80, 1)',
        height: 50,
        zIndex: 2,
        position: 'absolute',
        flexDirection: 'row',
        right: 0,
        left: 0,
        transition: Device.isWeb ? 'transform .16s linear' : null,
        marginTop: Device.isWeb ? TOP_BAR_TOTAL_HEIGHT : null
    },
    iconContainer: { width: 50, height: '100%', justifyContent: 'center' },
    icon: { width: 25, marginHorizontal: 10 },
    innerContainer: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    separator: { width: 50, height: '100%' }
};

export default StyleSheet.create(baseStyles);
